<template>
  <b-overlay :show="tableLoading" rounded="sm">
    <b-card class="inner-block location-list">
      <b-card-header>
        <b-row class="mt-2" v-if="!customer_id">
          <b-col cols="12" class="d-d-flex align-items-center search-field">
            <div class="input-group p-0">
              <b-input-group class="p-0 mb-0">
                <b-input id="search-location-filter" type="text" :placeholder="$translate('search_filter')" v-model="query"></b-input>
                <template #append>
                  <b-button id="add-location-btn" variant="primary" @click="addLocation" v-if="hasPermissionCreate"><img v-b-tooltip.hover
                      :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
                </template>
                <template #prepend>
                  <div class="d-flex">
                    <div class="querySelect dd w-100">
                      <b-form-select class="form-control w-100 h-100" id="input-1" v-model="filters.queryOptionsValue"
                        :options="queryOptions" value-field="value" text-field="name" block />
                    </div>
                    <!-- <div class="vr bg-dark m-1"></div> -->
                  </div>
                </template>
              </b-input-group>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-2" v-else>
          <b-col cols="12" class="d-flex align-items-center justify-content-center"><strong>{{ title }}</strong></b-col>
          <b-col offset="11" cols="1">
            <div class="d-flex gap-2">
              <b-button id="add-location-button" class="mt-2 mt-md-0 ms-2" variant="blue-icon" @click="addLocation" :title="$addLabel()">
                <img src="@/assets/images/icon/gradient-add.svg" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body>
        <b-col class="page-block" v-if="!blockSearch"><strong>{{ $translate("page") }}: {{ pagination.page }}
            {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
            {{ pagination.total }}</strong></b-col>
        <b-col cols="12" class="overflow-auto w-100 mt-4">
          <b-table responsive :fields="locationFields" :items="locations">
            <template>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <!-- <strong>{{ $translate('loading') }}</strong> -->
              </div>
            </template>
            <template #cell(id)="row">
              <b-button :id="'location-item-'+row.item.id" @click="showItem(row)" class="me-2" variant="pink-button">
                <img src="@/assets/images/icon/view.svg" />
              </b-button>
            </template>
          </b-table>
        </b-col>
        <b-col v-if="!blockSearch">
          <b-pagination class="justify-content-center mt-4" v-model="pagination.page" :total-rows="pagination.total"
            :per-page="pagination.pageSize" aria-controls="locationTable" :prev-text="$translate('previous')"
            :next-text="$translate('next')" pills align="center"></b-pagination>
        </b-col>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import _ from "lodash";
import permissionsMixins from "@/mixins/permissionsMixins";

export default {
  name: "locations-ListItems",
  mixins: [permissionsMixins],

  props: {
    customer_id: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: "Addresses",
    },
  },

  data() {
    return {
      query: "",
      tableLoading: false,
      filters: { is_warehouse: null, queryOptionsValue: "starts_with" },
      queryOptions: [
        { value: "contains", name: this.$translate("contains") },
        { value: "starts_with", name: this.$translate("starts_with") },
        { value: "ends_with", name: this.$translate("ends_with") },
      ],
    };
  },

  watch: {
    "pagination.page": function (newPage) {
      this.changePage(newPage);
    },
    query: _.debounce(function (query) {
      this.$router.push({ query: { query } });
      this.doSearch();
    }, 200),

    filters: {
      handler: function (filters) {
        console.log("filters", filters);
        this.doSearch();
      },
      deep: true,
    },
    locations: {
      handler: function () {
        this.tableLoading = false;
      },
      deep: true,
    },
  },
  mounted() {
    console.log("locations", this.locations);
    if (this.customer_id) {
      console.log("customer_id", this.customer_id);
      ////clear locations for customer
      this.$store.commit("locations/SET_LOCATIONS", []);
    }
    this.doSearch();
  },
  computed: {
    blockSearch() {
      return this.customer_id && this.locations.length <= 15;
    },
    locationFields() {
      const fields = [
        {
          key: "id",
          label: this.$translate("actions"),
        },
        {
          key: "name",
          label: this.$translate("name"),
        },
        {
          key: "address1",
          label: this.$translate("address1"),
        },
        {
          key: "city",
          label: this.$translate("city"),
        },
      ];
      console.log("customer_id", this.customer_id);
      if (!this.customer_id) {
        fields.push({
          key: "is_warehouse",
          label: this.$translate("is_warehouse"),
          formatter: (value) => {
            return value ? "Yes" : "No";
          },
        });
      }
      return fields;
    },
    user() {
      return this.$store.state.user;
    },
    permissions() {
      return this.$store.state.rolePermissions;
    },
    locations() {
      return this.$store.state.locations.locations;
    },
    pageCount() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize);
    },
    pagination() {
      return this.$store.state.locations.pagination || { page: 1 };
    },
    user_permissions() {
      return this.$store.getters.user_permissions;
    },
  },
  methods: {
    async doSearch() {
      try {
        this.tableLoading = true;
        const {
          query,
          pagination: { page },
          filters,
        } = this;
        filters.customer_id = this.customer_id;
        await this.$store.dispatch("locations/fetchLocations", {
          query,
          page,
          filters,
        });
      } catch (error) {
        console.error("loading error", error);
      } finally {
        this.tableLoading = false;
      }
    },
    async correctLocations() {
      try {
        this.tableLoading = true;
        await this.$store.dispatch("locations/correctCustomerLocations");
        this.doSearch();
      } catch (error) {
        console.error("loading error", error);
      } finally {
        this.tableLoading = false;
      }
    },

    addLocation() {
      if (this.customer_id) {
        this.$emit("create-location");
      } else {
        this.$router.push(`${this.$route.path}/0`);
      }
    },
    showItem(row) {
      if (this.customer_id) {
        this.$emit("set-location", row.item);
      } else {
        this.$router.push(`/ams/locations/${row.item.id}`);
      }
    },

    changePage(page) {
      this.$router.push({ query: { page } });
      this.doSearch();
    },


  },
};
</script>
<style scoped>
.inner-block .btn.btn-primary.btn-block {
  right: 0;
  z-index: 100;
}

.inner-block .form-control {
  padding-left: 8px;
}

.querySelect {
  height: unset;
}
</style>
